import React from "react";
import { Navigate, useLocation } from "react-router-dom";
/** Services Import */
import Commons from "../Services/Common/Common";

function RequireAuth({ children }) {
  let auth = Commons.Storages("get", "auth");
  let location = useLocation();

  return auth.auth ? (
    location.pathname === "/" ? (
      <Navigate replace to="/Login" />
    ) : (
      children
    )
  ) : location.pathname === "/" ? (
    children
  ) : location.pathname === "/auth" ? (
    children
  ) : (
    <Navigate replace to="/" />
  );
}

export default RequireAuth;
